import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import { ToastProgrammatic as Toast } from 'buefy';
import Error from '../error';
import sha256 from 'crypto-js/sha256';
export default {
  name: "Login",
  data: function data() {
    return {
      inep: undefined,
      password: undefined,
      isSignInRequestInProgress: false
    };
  },
  methods: {
    login: function login() {
      var _this = this;
      this.$validator.validateAll().then(function (result) {
        if (result) {
          var adviser = {
            inep: _this.inep,
            password: sha256(_this.password).toString()
          };
          _this.isSignInRequestInProgress = true;
          _this.$store.dispatch('authRequest', adviser).then(function () {
            localStorage.setItem('inep', +_this.inep);
            _this.$store.commit('setInep', +_this.inep);
            _this.$store.dispatch('getSchool').then(function () {
              _this.$router.push('/home');
              _this.isSignInRequestInProgress = false;
            });
          }).catch(function (error) {
            if (error.data) {
              Toast.open(Error[error.data.errorCode]);
            }
          }).then(function () {
            _this.isSignInRequestInProgress = false;
          });
        }
      });
    }
  }
};